import React, { Fragment } from 'react'
import List from '../../../../components/Project/Resources/Vehicles/List'
import VehicleModal from '../../../../components/Project/Resources/Vehicles/VehicleModal'

function Vehicles(props) {
  return (
    <Fragment>
      <VehicleModal {...props} />
      <List {...props} />
    </Fragment>
  )
}

Vehicles.propTypes = {}
Vehicles.defaultProps = {}

export default Vehicles
